module.exports = __webpack_public_path__ + "img/262-3.062ac256.png";